import loadMore from './loadMore';

export default () => {
  loadMore('js-stories-list', 'js-load-stories', '/ajax/getStories');
  loadMore('js-blogs-list', 'js-load-blogs', '/ajax/getBlogs');
  loadMore('js-result-list', 'js-load-results', '/ajax/getSearchResults');
};
